import { Box, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import { ArrowGray } from "~/icons";

export const DesktopNavigationButtons: FC = () => {
  return (
    <Flex gap={8}>
      <Box
        as="span"
        border={{ radius: "4px" }}
        bg="surface-neutral-default"
        cursor="pointer"
        className="custom-prev"
      >
        <ArrowGray
          viewBox="0 0 32 32"
          width={40}
          height={40}
          className="rotate-180"
        />
      </Box>

      <Box
        as="span"
        border={{ radius: "4px" }}
        bg="surface-neutral-default"
        cursor="pointer"
        className="custom-next"
      >
        <ArrowGray width={40} height={40} viewBox="0 0 32 32" />
      </Box>
    </Flex>
  );
};
